import { map, mergeMap } from 'rxjs/operators';
import { Observable } from 'rxjs';

// import 'rxjs/add/operator/map';
// import 'rxjs/add/operator/mergeMap';
// import { Observable } from "rxjs/internal/Observable";

const debuggerOn = false;

// export declare function debug<T, R>(this: Observable<T>, project: (value: T, index: number) => R, thisArg?: any): Observable<R>;
//
// export declare function debugToConsole<T>(message: string) => (source: Observable<T>) => new Observable<T>((subscriber) => {
export const debugToConsole = <T>(message: string) => (source: Observable<T>) => new Observable<T>((subscriber) => {
  source.subscribe({
    next(value) {
      if (debuggerOn) {
        console.log(message, value);
      }

      subscriber.next(value);
    },
    error(err) {
      subscriber.error(err);
    },
    complete() {
      subscriber.complete();
    },
  });
});

// // Uncomment to see it works
// Observable.of("ad").pipe(
//  debugToConsole("to console"),
// ).subscribe();

declare module 'rxjs/internal/Observable' {
  interface Observable<T> {
    debug: (...any) => Observable<T>;
  }
}

// import { MonoTypeOperatorFunction, PartialObserver } from '../types';
// export declare function tap<T>(next?: (x: T) => void, error?: (e: any) => void, complete?: () => void): MonoTypeOperatorFunction<T>;
// export declare function tap<T>(observer: PartialObserver<T>): MonoTypeOperatorFunction<T>;

// import { Observable } from 'rxjs';
export declare function debug<T, R>(this: Observable<T>, project: (value: T, index: number) => R, thisArg?: any):  Observable<R>;

// Note VT: just test
// https://blog.angular-university.io/debug-rxjs/
Observable.prototype.debug = function (message: string) {
  // https://www.academind.com/learn/javascript/rxjs-6-what-changed/
  return this.tap( // RxJS 6 Changes: operator was renamed do() => tap()
    (nextValue) => {
      if (debuggerOn) {
        console.log(message, nextValue);
      }
    },
    function (error) {
      if (debuggerOn) {
        console.error('ERROR >>> ', message, error);
      }
    },
    function () {
      if (debuggerOn) {
        console.log('Completed.');
      }
    }
  );
};
